import {Snackbar, SnackbarContent, withStyles} from "@material-ui/core";
import React from "react";


const style = theme => ({
    error: {
        backgroundColor: theme.palette.error.dark,
        color: '#fff'
    },
    // Faltava: usado em vários pontos do app (color: "success") mas nunca teve estilo definido.
    success: {
        backgroundColor: '#2D9B52', // --cor-sucesso da marca
        color: '#000' // texto branco fica em 3.55:1 (reprova AA); preto garante 5.92:1
    },
    // Sem laranja/amarelo na marca para "atenção". Reaproveita o amarelo já
    // usado no gauge de horas (Chart/utils.js) para manter a mesma convenção
    // dentro do app.
    warning: {
        backgroundColor: '#ffee58',
        color: '#330072'
    },
    // Antes #FF7F30 (laranja, fora da marca). Nível intermediário de alerta,
    // abaixo de "error": vermelho-erro "puro" (main), enquanto "error" usa
    // a variante mais escura (dark).
    secondary: {
        backgroundColor: theme.palette.error.main,
        color: '#fff'
    },
    primary: {
        backgroundColor: theme.palette.primary.dark
    },
});

function Notification(props) {
    const {classes, color, open, ContentProps, anchorOrigin, ...others} = props;
    return <Snackbar
        {...others}
        anchorOrigin={anchorOrigin}
        ContentProps={ContentProps}
        color={color}
        open={open}>
        <SnackbarContent
            {...others}
            className={classes[color]}
        />
    </Snackbar>;
}

export default withStyles(style)(Notification);
